<template>
    <Form class="form" @submit="login">

        <!-- Email -->
        <Input  v-model="email"
                type="email"
                class="form-control-lg mb-2"
                :placeholder="$t('login.Your e-mail')"
                :hasError="!!emailError"
                @input="errors.email = []"
                focus />
        <Error v-if="errors.email" :error="errors.email" />
        <InputHint class="mb-3">{{ $t('login.Your e-mail') }}</InputHint>
        <!-- / Email -->

        <!-- Password -->
        <Input  v-model="password"
                type="password"
                class="form-control-lg"
                :placeholder="$t('login.Your password')"
                :hasError="!!passwordError"
                @input="errors.password = []" />
        <Error v-if="errors.password" :error="errors.password" />
        <InputHint class="mb-3">{{ $t('login.Your password') }}</InputHint>
        <!-- / Password -->

        <!-- Others errors -->
        <div v-if="errors.other" class="my-2">
            <Error :key="index" v-for="(error, index) in errors.other" :error="error" />
        </div>
        <!-- / Others errors -->

        <!-- Submit -->
        <div class="text-center">
            <Button type="submit" large class="mt-3" :disabled="loading" @click="login">
                <Spinner v-if="loading" /> {{ $t('login.Login') }}
            </Button>
        </div>
        <!-- / Submit -->

    </Form>
</template>

<script>
    import Form from '../Form/Form'
    import Input from '../Form/Input'
    import Error from '../Form/Error'
    import Button from '../Button'
    import Spinner from '../Loaders/Spinner'
    import InputHint from '../Form/InputHint'

    export default {
        props: {
            errors: {
                type: Object,
                required: false,
                default: () => { return {} }
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                email: '',
                password: ''
            }
        },
        components: {
            InputHint,
            Form,
            Error,
            Button,
            Input,
            Spinner
        },
        methods: {
            login() {
                this.$emit('login', {
                    email: this.email,
                    password: this.password
                });
            }
        },
        computed: {
            emailError: function() {
                return this.errors.email && this.errors.email.length > 0 ? this.errors.email[0] : null;
            },
            passwordError: function() {
                return this.errors.password && this.errors.password.length > 0 ? this.errors.password[0] : null;
            }
        }
    }
</script>
